export const writeToClipboard = async (value: string) => {
  return navigator.clipboard.writeText(value);
};
